import axios from 'axios';
import { environment } from '@environments/environment';
import { constructRequestForProductsItemFeatures } from '@utils/serviceUtils/RequestFormatter';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { Option } from '@utils/pageConfig/Types';
import { ItemFeaturesResp } from '@models/Products';
import { ProductType } from '@pages/product-analyzer/Product';
import { getQueryClient } from '../../queries/QueryClientWrapper';

export const getItemFeatures = async (
  clientId: number,
  productType: ProductType,
  countryId: string,
  periodType: Periodicity,
  productGroup: Option | undefined,
  itemIds: string[],
): Promise<ItemFeaturesResp[]> => {
  try {
    const qc = getQueryClient('products');

    const queryKey = [
      'products-item-features',
      {
        clientId,
        productType,
        countryId,
        periodType,
        productGroup,
        itemIds,
      },
    ] as const;

    const url = `${environment.baseUrl}/v2/products/item-features`;
    const body = constructRequestForProductsItemFeatures(
      clientId,
      productType,
      countryId,
      productGroup,
      periodType,
      itemIds,
    );

    return await qc.ensureQueryData<ItemFeaturesResp[]>({
      queryKey,
      queryFn: async ({ signal }) => {
        const { data } = await axios.post<ItemFeaturesResp[]>(url, body, { signal });
        return data;
      },
    });
  } catch (err: any) {
    throw new Error(`An error has occurred: ${err?.message ?? err}`);
  }
};
